import { gql } from "@apollo/client";

export const UPDATE_SESSION_RECORD = gql`mutation updateSessionRecordStatus($cId: UUID!, $sId: UUID!, $sjId: UUID!,$isRecordStart:Boolean!,$recordStarttime:Datetime) {
    updateSessionRecordStatus(
      input: {pCId: $cId, pIsRecordStsrt: $isRecordStart, pReocrdStartTime: $recordStarttime, pSessionId: $sId, pSubjectId: $sjId}
    ) {
      clientMutationId
    }
}`;
